import { DrugReview, FetchAttr } from '../types';
import { getData } from '../utils';

export type GetDrugReviewsRequest = {
  drugTranslitName: string;
  pageSize: number;
  pageNumber: number;
};

export type GetDrugReviewsResponse = DrugReview[];

const getDrugReviews = async (
  requestObj: GetDrugReviewsRequest,
  attr?: FetchAttr
): Promise<GetDrugReviewsResponse> => {
  const { drugTranslitName } = requestObj;
  const response = await getData(`drug/${drugTranslitName}/rates`, attr, {
    pageNumber: requestObj?.pageNumber?.toString(),
    pageSize: requestObj?.pageSize?.toString()
  });
  return response;
};

export default getDrugReviews;
